import React from "react";
import "./Trial.css";

const Trial = () => {
    return (
        <div className="trial-container">
            <h2 className="trial-heading">
                Discover how our platform can transform your business —<br />
                See it in action.
            </h2>
            <a href="/Demo" className="trial-button">
                Request a Demo ↗
            </a>
        </div>
    );
};

export default Trial;
